import { Item } from '@sitecore-jss/sitecore-jss-nextjs';
import { SitecorePageProps } from 'lib/page-props';
import type { AppProps } from 'next/app';
import { I18nProvider } from 'next-localization';

import 'assets/main.scss';

import { ExternalLinksWarningModal } from 'components/Modals';
import { ExternalLinkWarningFields } from 'models/external-links-warning-types';
import Bootstrap from 'src/Bootstrap';

// import 'assets/sitecore-rte-main.scss';  // only include this bundle to compile it with next:build and copy it to default.css for Sitecore RTE styles

function App({ Component, pageProps }: AppProps<SitecorePageProps>): React.JSX.Element {
  const { dictionary, ...rest } = pageProps;

  const linkWarning = pageProps.layoutData?.sitecore?.route?.fields?.linkWarning as Item;
  const linkWarningFields = linkWarning?.fields as ExternalLinkWarningFields;
  // Use the next-localization (w/ rosetta) library to provide our translation dictionary to the app.
  // Note Next.js does not (currently) provide anything for translation, only i18n routing.
  // If your app is not multilingual, next-localization and references to it can be removed.

  return (
    <>
      <Bootstrap {...pageProps} />
      <I18nProvider lngDict={dictionary} locale={pageProps.locale}>
        <>
          <Component {...rest} />
          <ExternalLinksWarningModal warningFields={linkWarningFields} />
        </>
      </I18nProvider>
    </>
  );
}

export default App;
